import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './utils/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import SentryErrorBoundary from './components/monitoring/ErrorBoundary';
import { HelmetProvider } from 'react-helmet-async';

// Defer monitoring initialization so Sentry/GA/web-vitals load AFTER first paint
if (typeof window !== 'undefined') {
  const loadMonitoring = () => {
    import('./utils/monitoring').then(({ initializeMonitoring }) => {
      initializeMonitoring();
    });
  };
  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadMonitoring);
  } else {
    setTimeout(loadMonitoring, 1);
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SentryErrorBoundary>
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <App />
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </SentryErrorBoundary>
  </React.StrictMode>
);